/* unplugin-vue-components disabled */import script from "./navigationbarM.vue?vue&type=script&setup=true&lang=js"
export * from "./navigationbarM.vue?vue&type=script&setup=true&lang=js"

import "./navigationbarM.vue?vue&type=style&index=0&id=c398afb2&scoped=true&lang=less"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_e16590e957a4dff7099c04c4dde027e6/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c398afb2"]])

export default __exports__